function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 249,
  height: 106,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M103.567 58H104.659V51.484H103.567V58ZM104.119 50.14C104.551 50.14 104.851 49.852 104.851 49.408C104.851 48.988 104.551 48.7 104.119 48.7C103.687 48.7 103.387 48.988 103.387 49.408C103.387 49.852 103.687 50.14 104.119 50.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.872 58H107.964V53.272C108.564 52.6 109.116 52.276 109.608 52.276C110.436 52.276 110.82 52.792 110.82 54.016V58H111.912V53.272C112.524 52.6 113.052 52.276 113.556 52.276C114.384 52.276 114.768 52.792 114.768 54.016V58H115.86V53.872C115.86 52.204 115.224 51.316 113.88 51.316C113.088 51.316 112.404 51.832 111.732 52.564C111.468 51.796 110.928 51.316 109.932 51.316C109.152 51.316 108.468 51.808 107.904 52.432H107.868L107.772 51.484H106.872V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M119.481 58.156C120.285 58.156 121.017 57.736 121.641 57.22H121.677L121.773 58H122.673V53.992C122.673 52.384 122.001 51.316 120.417 51.316C119.373 51.316 118.449 51.784 117.849 52.168L118.281 52.924C118.797 52.576 119.481 52.228 120.237 52.228C121.305 52.228 121.581 53.032 121.581 53.872C118.809 54.184 117.573 54.892 117.573 56.308C117.573 57.484 118.389 58.156 119.481 58.156ZM119.793 57.28C119.145 57.28 118.641 56.98 118.641 56.236C118.641 55.396 119.385 54.856 121.581 54.592V56.416C120.945 56.98 120.429 57.28 119.793 57.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M126.95 61C128.966 61 130.25 59.956 130.25 58.744C130.25 57.676 129.482 57.196 127.97 57.196H126.698C125.822 57.196 125.558 56.908 125.558 56.488C125.558 56.128 125.738 55.912 125.978 55.708C126.266 55.852 126.626 55.936 126.95 55.936C128.27 55.936 129.326 55.06 129.326 53.668C129.326 53.104 129.11 52.624 128.798 52.324H130.13V51.484H127.862C127.634 51.4 127.31 51.316 126.95 51.316C125.63 51.316 124.502 52.216 124.502 53.644C124.502 54.424 124.922 55.048 125.354 55.396V55.444C125.018 55.684 124.622 56.116 124.622 56.656C124.622 57.172 124.874 57.52 125.222 57.724V57.772C124.61 58.168 124.262 58.696 124.262 59.248C124.262 60.376 125.354 61 126.95 61ZM126.95 55.192C126.194 55.192 125.558 54.592 125.558 53.644C125.558 52.684 126.182 52.12 126.95 52.12C127.718 52.12 128.342 52.696 128.342 53.644C128.342 54.592 127.694 55.192 126.95 55.192ZM127.106 60.256C125.93 60.256 125.222 59.8 125.222 59.104C125.222 58.72 125.414 58.336 125.882 58C126.17 58.072 126.482 58.108 126.722 58.108H127.85C128.714 58.108 129.182 58.312 129.182 58.912C129.182 59.596 128.354 60.256 127.106 60.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M133.968 58.156C134.856 58.156 135.552 57.856 136.128 57.484L135.732 56.764C135.252 57.088 134.736 57.28 134.1 57.28C132.864 57.28 132.012 56.392 131.94 55H136.332C136.356 54.844 136.38 54.616 136.38 54.376C136.38 52.516 135.444 51.316 133.788 51.316C132.276 51.316 130.848 52.636 130.848 54.748C130.848 56.896 132.24 58.156 133.968 58.156ZM131.928 54.208C132.06 52.936 132.876 52.192 133.8 52.192C134.82 52.192 135.42 52.9 135.42 54.208H131.928Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M137.937 58H142.761V57.088H140.997V49.444H140.157C139.677 49.732 139.113 49.936 138.333 50.068V50.776H139.893V57.088H137.937V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M249 0V106",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 249,
  width: 106,
  height: 106,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M281.104 58H282.196V51.484H281.104V58ZM281.656 50.14C282.088 50.14 282.388 49.852 282.388 49.408C282.388 48.988 282.088 48.7 281.656 48.7C281.224 48.7 280.924 48.988 280.924 49.408C280.924 49.852 281.224 50.14 281.656 50.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M284.409 58H285.501V53.272C286.101 52.6 286.653 52.276 287.145 52.276C287.973 52.276 288.357 52.792 288.357 54.016V58H289.449V53.272C290.061 52.6 290.589 52.276 291.093 52.276C291.921 52.276 292.305 52.792 292.305 54.016V58H293.397V53.872C293.397 52.204 292.761 51.316 291.417 51.316C290.625 51.316 289.941 51.832 289.269 52.564C289.005 51.796 288.465 51.316 287.469 51.316C286.689 51.316 286.005 51.808 285.441 52.432H285.405L285.309 51.484H284.409V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M297.018 58.156C297.822 58.156 298.554 57.736 299.178 57.22H299.214L299.31 58H300.21V53.992C300.21 52.384 299.538 51.316 297.954 51.316C296.91 51.316 295.986 51.784 295.386 52.168L295.818 52.924C296.334 52.576 297.018 52.228 297.774 52.228C298.842 52.228 299.118 53.032 299.118 53.872C296.346 54.184 295.11 54.892 295.11 56.308C295.11 57.484 295.926 58.156 297.018 58.156ZM297.33 57.28C296.682 57.28 296.178 56.98 296.178 56.236C296.178 55.396 296.922 54.856 299.118 54.592V56.416C298.482 56.98 297.966 57.28 297.33 57.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M304.487 61C306.503 61 307.787 59.956 307.787 58.744C307.787 57.676 307.019 57.196 305.507 57.196H304.235C303.359 57.196 303.095 56.908 303.095 56.488C303.095 56.128 303.275 55.912 303.515 55.708C303.803 55.852 304.163 55.936 304.487 55.936C305.807 55.936 306.863 55.06 306.863 53.668C306.863 53.104 306.647 52.624 306.335 52.324H307.667V51.484H305.399C305.171 51.4 304.847 51.316 304.487 51.316C303.167 51.316 302.039 52.216 302.039 53.644C302.039 54.424 302.459 55.048 302.891 55.396V55.444C302.555 55.684 302.159 56.116 302.159 56.656C302.159 57.172 302.411 57.52 302.759 57.724V57.772C302.147 58.168 301.799 58.696 301.799 59.248C301.799 60.376 302.891 61 304.487 61ZM304.487 55.192C303.731 55.192 303.095 54.592 303.095 53.644C303.095 52.684 303.719 52.12 304.487 52.12C305.255 52.12 305.879 52.696 305.879 53.644C305.879 54.592 305.231 55.192 304.487 55.192ZM304.643 60.256C303.467 60.256 302.759 59.8 302.759 59.104C302.759 58.72 302.951 58.336 303.419 58C303.707 58.072 304.019 58.108 304.259 58.108H305.387C306.251 58.108 306.719 58.312 306.719 58.912C306.719 59.596 305.891 60.256 304.643 60.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M311.505 58.156C312.393 58.156 313.089 57.856 313.665 57.484L313.269 56.764C312.789 57.088 312.273 57.28 311.637 57.28C310.401 57.28 309.549 56.392 309.477 55H313.869C313.893 54.844 313.917 54.616 313.917 54.376C313.917 52.516 312.981 51.316 311.325 51.316C309.813 51.316 308.385 52.636 308.385 54.748C308.385 56.896 309.777 58.156 311.505 58.156ZM309.465 54.208C309.597 52.936 310.413 52.192 311.337 52.192C312.357 52.192 312.957 52.9 312.957 54.208H309.465Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M314.946 58H320.478V57.052H317.994C317.538 57.052 317.01 57.1 316.554 57.136C318.582 55 320.046 53.404 320.046 51.796C320.046 50.284 319.062 49.288 317.49 49.288C316.374 49.288 315.618 49.804 314.898 50.584L315.534 51.196C316.014 50.632 316.638 50.176 317.358 50.176C318.45 50.176 318.978 50.872 318.978 51.844C318.978 53.248 317.526 54.784 314.946 57.352V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var SvgTemplate6Grey = function SvgTemplate6Grey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 106,
    viewBox: "0 0 355 106",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate6Grey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template6_grey.867daa8c.svg";
export { ForwardRef as ReactComponent };